import { render, staticRenderFns } from "./RtnInvoiceDetails_Details.vue?vue&type=template&id=20c69b1f&"
import script from "./RtnInvoiceDetails_Details.vue?vue&type=script&lang=js&"
export * from "./RtnInvoiceDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports